export class InvalidParameterError extends Error {}

export class SignError extends Error {}

export class VerifySignError extends Error {}
